const actionTypeIdentifier = "C276945F-464E-4EC9-B45D-420EFB1D523B";

export const getCircuitPIPInformationDetails = `GET-CIRCUIT-PIP-INFORMATION-DETAILS-${actionTypeIdentifier}`;

export const pipInformationFormModel = {
    portSpeed: null,
    carrierQOSProfile: null,
    asnNumber: null,
    voiceCAR: null,
    routingProtocol: null,
    vpnName: null,
    voiceCARSpeed: null,
    asnNewOrExisting: null,
    siteOfOrigin: null,
};